import { useEffect } from 'react';
import { usePlayerMediaTracking, useTracking } from 'state/tracking';
import { DrawableAudioPlayer } from 'utils/audio/types';

interface UsePlaybackEventTrackingConfig {
  loadedUnitId: string | undefined;
  player: DrawableAudioPlayer | undefined;
  playingUnitId: string | undefined;
  volume: number;
}

export default function usePlaybackEventTracking({
  loadedUnitId,
  playingUnitId,
  player,
  volume,
}: UsePlaybackEventTrackingConfig) {
  const { trackUnitPlayed } = useTracking();
  usePlayerMediaTracking({ player, unitId: loadedUnitId });

  useEffect(() => {
    // trackUnitPlayed will prevent tracking playback of the same unit multiple
    // times, so we don't have to worry about how many times this effect runs
    if (playingUnitId && volume > 0) {
      trackUnitPlayed({ resultId: playingUnitId });
    }
  }, [playingUnitId, trackUnitPlayed, volume]);
}
